<script>
import { Toast } from 'bootstrap'

export default {
  name: 'SingleToast',
  emits: ['destroy'],
  props: {
    title: String,
    message: String,
    type: String,
    errors: Object,
    stay: Number,
    showSpinner: { type: Boolean, default: false },
    autohide: { type: Boolean, default: true },
    id: String,
  },
  computed: {
    classType() {
      return this.type === 'error' ? 'danger' : this.type
    },
    classes() {
      return [`type-${this.classType}`]
    },
    progressBarClasses() {
      return [`bg-${this.classType}`]
    },
    iconClasses() {
      return {
        danger: 'mi-outlined mi-error',
        success: 'mi-outlined mi-check',
        warning: 'mi-outlined mi-warning',
      }[this.classType]
    },
  },
  mounted() {
    const toast = new Toast(this.$el, { delay: this.stay, autohide: this.autohide })
    toast.show()
    this.$el.addEventListener('hidden.bs.toast', () => {
      this.$emit('destroy', this.id)
    })
  },
}
</script>

<template lang="pug">
.toast(:class="classes" aria-atomic="true" aria-live="assertive" role="alert")
  .toast-header
    .icon(:class="iconClasses")
    .me-auto(:class="{ bold: title?.length }" v-html="title?.length ? title : message")
    button.btn-close(aria-label="Close" data-bs-dismiss="toast" type="button")
  .toast-body(v-if="title?.length" v-html="message")
  .progress-bar.progress-bar-striped.progress-bar-animated(
    v-if="showSpinner"
    :classes="progressBarClasses"
  )
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables.scss' as themeVariables;
@import '../../../../frontend_stylesheets/_variables.scss';

.toast {
  width: 400px;
  border-width: 1px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15);
  border-radius: $border-radius;
  background: map.get(themeVariables.$colors, surfaceBright);

  &.type-success {
    border-color: map.get(themeVariables.$colors, success);

    .icon {
      color: map.get(themeVariables.$colors, success);
    }
  }

  &.type-danger {
    border-color: map.get(themeVariables.$colors, error);

    .icon {
      color: map.get(themeVariables.$colors, error);
    }
  }

  &.type-warning {
    border-color: map.get(themeVariables.$colors, warning);

    .icon {
      color: map.get(themeVariables.$colors, warning);
    }
  }

  &.type-info {
    border-color: map.get(themeVariables.$colors, secondary);

    .icon {
      color: map.get(themeVariables.$colors, secondary);
    }
  }
  .erebus-app[data-theme='dark'] & {
    box-shadow: 0px 1px 2px 0px rgba(255, 255, 255, 0.3), 0px 2px 6px 2px rgba(255, 255, 255, 0.15);
  }
}

.icon {
  margin-right: 8px;
}

.progress-bar {
  height: 5px;
}

.toast-header {
  padding: 12px;
  background: transparent;
  color: map.get(themeVariables.$colors, onSurface);

  .btn-close {
    .erebus-app[data-theme='dark'] & {
      filter: invert(1);
    }
  }
}
</style>
